// extracted by mini-css-extract-plugin
export default {"header":"Login_header__+cFFh","subheader":"Login_subheader__YQfMU","container":"Login_container__-h4N5","button":"Login_button__bPXVQ"};